import {
  GET_VENDOR_CAT_PROFILE,
  GET_VENDOR_CAT_PROFILE_FAIL,
  GET_VENDOR_CAT_PROFILE_SUCCESS,
  GET_VENDOR_CATS,
  GET_VENDOR_CATS_FAIL,
  GET_VENDOR_CATS_SUCCESS,
  ADD_NEW_VENDOR_CAT,
  ADD_VENDOR_CAT_SUCCESS,
  ADD_VENDOR_CAT_FAIL,
  UPDATE_VENDOR_CAT,
  UPDATE_VENDOR_CAT_SUCCESS,
  UPDATE_VENDOR_CAT_FAIL,
  DELETE_VENDOR_CAT,
  DELETE_VENDOR_CAT_SUCCESS,
  DELETE_VENDOR_CAT_FAIL,
} from "./actionTypes"

export const getVendor_cats = ({is_active,offset='',page_size=''}) => ({
  type: GET_VENDOR_CATS,
  payload:{is_active,offset,page_size}
})

export const getVendor_catsSuccess = vendor_cats => ({
  type: GET_VENDOR_CATS_SUCCESS,
  payload: vendor_cats,
})

export const getVendor_catsFail = error => ({
  type: GET_VENDOR_CATS_FAIL,
  payload: error,
})

export const addNewVendor_cat = user => ({
  type: ADD_NEW_VENDOR_CAT,
  payload: user,
})

export const addVendor_catSuccess = user => ({
  type: ADD_VENDOR_CAT_SUCCESS,
  payload: user,
})  

export const addVendor_catFail = error => ({
  type: ADD_VENDOR_CAT_FAIL,
  payload: error,
})

export const updateVendor_cat = user => ({
  type: UPDATE_VENDOR_CAT,
  payload: user,
})

export const updateVendor_catSuccess = user => ({
  type: UPDATE_VENDOR_CAT_SUCCESS,
  payload: user,
})

export const updateVendor_catFail = error => ({
  type: UPDATE_VENDOR_CAT_FAIL,
  payload: error,
})

export const deleteVendor_cat = user => ({
  type: DELETE_VENDOR_CAT,
  payload: user,
})

export const deleteVendor_catSuccess = user => ({
  type: DELETE_VENDOR_CAT_SUCCESS,
  payload: user,
})

export const deleteVendor_catFail = error => ({
  type: DELETE_VENDOR_CAT_FAIL,
  payload: error,
})

export const getVendor_catProfile = () => ({
  type: GET_VENDOR_CAT_PROFILE,
})

export const getVendor_catProfileSuccess = userProfile => ({
  type: GET_VENDOR_CAT_PROFILE_SUCCESS,
  payload: userProfile,
})

export const getVendor_catProfileFail = error => ({
  type: GET_VENDOR_CAT_PROFILE_FAIL,
  payload: error,
})
